import { format } from 'date-fns';
import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../layout.service';
import { CellSetting } from '../cell-setting';
import * as g from 'src/app/globals';
import { FieldDataType } from '@app/models/module-structure';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-bulk-download-report',
  templateUrl: './bulk-download-report.component.html',
  styleUrls: ['./bulk-download-report.component.less'],
})
export class BulkDownloadReportComponent implements OnInit {
  global = g;

  filterFields: any[];

  documentIsLoading = false;

  downloadingRes = 0;
  downloadingResTitle = '';
  downloadingResMessage = '';

  filterFieldsSectionID = 0;
  tableColSectionID = 0;
  documentQryID = 0;

  generatingIsLoading = false;

  documentTableCols: any[];
  dataTable: { name: string; dataset: any[] };
  cellSettings: CellSetting[] = [];

  constructor(
    private layoutService: LayoutService,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.filterFieldsSectionID = this.global.bd_FilterSectionID;
    this.tableColSectionID = this.global.bd_TableSectionID;
    this.documentQryID = this.global.bd_DocumentQryID;

    this.documentIsLoading = false;
    this.generatingIsLoading = false;
    this.cellSettings = [];

    this.downloadingRes = 0;
    this.downloadingResTitle = '';
    this.downloadingResMessage = '';

    this.getDocumentFilterFields();
    this.getDocumentForDownloadCol();

    this.dataTable = {
      name: '',
      dataset: [],
    };
    this.dataTable.name = 'bulkDownload';
  }

  getDocumentFilterFields(): void {
    this.layoutService
      .getFilterFields(this.filterFieldsSectionID)
      .subscribe((d: any) => {
        console.log({ FilterFields: d.Data.fields });
        this.filterFields = d.Data.fields;
      });
  }

  getDocumentForDownloadCol(): void {
    this.layoutService
      .getSectionTableColumns(this.tableColSectionID)
      .subscribe((d: any) => {
        this.documentTableCols = JSON.parse(d.cols);
      });
  }

  getDocumentForDownload(): void {
    this.documentIsLoading = true;
    this.downloadingRes = 0;

    const filterData: { [key: string]: any } = {};
    this.filterFields.forEach((filterField) => {
      if (
        filterField.Value != null &&
        filterField.Value !== undefined &&
        filterField.Value !== ''
      ) {
        if (filterField.DataType == FieldDataType.Date) {
          filterData[filterField.FieldName] = moment(filterField.Value).format(
            'YYYY-MM-DD',
          );
        } else {
          filterData[filterField.FieldName] = filterField.Value;
        }
      } else {
        filterData[filterField.FieldName] = '';
      }
    });

    this.layoutService
      .executeQuery(this.documentQryID, filterData)
      .subscribe((result: any[]) => {
        this.documentIsLoading = false;
        this.dataTable.dataset = result;
        this.cellSettings = [];
      });
  }

  DownloadFiles() {
    this.generatingIsLoading = true;
    this.downloadingRes = 0;

    let rowsToProcess: any[] = [];
    let thereIsError: boolean = false;
    this.dataTable.dataset.forEach((row) => {
      let checked =
        row['SELECTED'] === true ||
        row['SELECTED'] === 'true' ||
        row['SELECTED'] === 'True';

      if (checked) {
        let rowToProcess = {
          DocEntry: Number(row['DocEntry']),
        };
        rowsToProcess.push(rowToProcess);
      }
    });

    if (thereIsError || rowsToProcess.length === 0) {
      this.message.info('There is no data to process');
      this.generatingIsLoading = false;
      return;
    }
    console.log({ rowsToProcess: rowsToProcess });

    const jsonToPush = JSON.stringify(rowsToProcess);
    const actionCode = 'DownloadDocumentFiles';

    this.layoutService
      .pushDataToBackend(jsonToPush, actionCode, jsonToPush)
      .subscribe((d: any) => {
        let result = d;
        console.log({ result: result });
        if (result.Has_Error) {
          this.downloadingRes = 1;
          this.downloadingResTitle = 'Downloading failed';
          this.downloadingResMessage = result.Error_Message;
        } else {
          let res = JSON.parse(result.Resault_Value);
          if (!res.Result.Success) {
            this.downloadingRes = 1;
            this.downloadingResTitle = 'Downloading failed';
            this.downloadingResMessage = res.Result.Msg;
          } else {
            this.downloadingRes = 2;
            this.downloadingResTitle = 'Downloading done';
          }
        }

        this.generatingIsLoading = false;
      });
  }
}
